import * as React from 'react';
import { useRef } from 'react';

import { use$ } from '@legendapp/state/react';
import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled, { css } from 'styled-components';

import { landscapeMediaMixin } from '../../hooks/use-vertical-breakpoint';

import { fullscreenStore } from '../../store';
import { testId } from '../../test-utils/constants';
import { ExitInteriorButton } from '../interior-view/exit-interior-button';
import { OptionSelection } from './options-selection';
import { PickerSelection } from './picker-selection';

export const OptionSelector = () => {
	const isFullscreenMode = use$(fullscreenStore.isFullscreenMode);
	const parentRef = useRef<HTMLDivElement>(null);

	return (
		<ControlsWrapper ref={parentRef} data-testid={testId('Controls_Wrapper')} $isFullscreenMode={isFullscreenMode}>
			<OptionSelection />
			<PickerSelection />
			<ExitInteriorButton />
		</ControlsWrapper>
	);
};

export const SliderMagicMixin = (isDoubleSliderVisible: boolean) => css`
	width: ${() => (isDoubleSliderVisible ? '100%' : 'auto')};
	overflow: ${() => (isDoubleSliderVisible ? 'hidden' : 'initial')};
`;

const DoubleSliderMixin = () => css`
	flex-direction: row-reverse;
	align-items: center;
	justify-content: space-between;

	gap: ${props => props.theme.size.static350};
`;

const ControlsWrapper = styled.div<{ $isFullscreenMode: boolean }>`
	grid-area: slider;

	// top center align in control panel
	margin: auto 0;

	display: flex;
	flex-direction: column;

	// Double masking, here and in slider
	mask-image: linear-gradient(
		to right,
		transparent 0px,
		black ${({ theme }) => theme.size.static150},
		black calc(100% - ${({ theme }) => theme.size.static150}),
		transparent 100%
	);

	@media (min-width: ${Breakpoints.b960}px) {
		${({ $isFullscreenMode }) => $isFullscreenMode && DoubleSliderMixin()};
		// Prevents overlap of slider and header in desktop orientation
		overflow: hidden;
	}

	${({ $isFullscreenMode }) => $isFullscreenMode && DoubleSliderMixin()};
	@media ${landscapeMediaMixin} {
		${DoubleSliderMixin()}
	}
`;
